// removed by extract-text-webpack-plugin
module.exports = {"tableContainer":"tableContainer--8ooW table-ijABF tableStriped-crSpx","totalsRow":"totalsRow-3usUg tableRowEmphasized-39rZ0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/workouts/dashboard/lifetime/_statsTable.css
// module id = 1289
// module chunks = 1